module.exports = __webpack_public_path__ + "icon-eye-lake.11db0d5e85c136062dfd.svg";